function normalizeText(text) {
  return String(text)
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

export function translateApiMessage(text, i18n) {
  if (!text || i18n.locale === 'pt-BR') return text

  const normalized = normalizeText(text)

  if (normalized.includes('nao e possivel continuar') && normalized.includes('cadastro')) {
    return i18n.t('cadastro.cannotContinue')
  }

  if (normalized.includes('confirme seus dados')) {
    return i18n.t('cadastro.confirmYourData')
  }

  if (normalized.includes('erro desconhecido') && normalized.includes('e-mail')) {
    return i18n.t('email.unknownVerificationError')
  }

  if (
    normalized.includes('tudo estiver correto') &&
    normalized.includes('redefin') &&
    normalized.includes('senha') &&
    normalized.includes('cadastrado')
  ) {
    return i18n.t('recover.successMessage')
  }

  return text
}
